import React from "react";
import { Badge } from "reactstrap";
import style from "./Badges.scss";
import { KYCStatus } from "./types";

const STATUS_CLASS = {
  [KYCStatus.ComplianceReview]: style.statusCompliance,
  [KYCStatus.ComplianceReviewCEO]: style.statusComplianceCEO,
  [KYCStatus.AdvisorReview]: style.statusAdvisor,
  [KYCStatus.EscalatedToCEO]: style.statusEscalated,
  [KYCStatus.Closed]: style.statusClosed,
  [KYCStatus.Rejected]: style.statusRejected,
};

const RISK_CLASS = {
  low: style.riskLow,
  conservative: style.riskLow,
  medium: style.riskMedium,
  moderate: style.riskMedium,
  high: style.riskHigh,
  agressive: style.riskHigh,
};

const getRiskClass = (value) => RISK_CLASS[String(value || "").toLowerCase()] || style.riskUnknown;

export const StatusBadge = ({ value }) => (
  <Badge className={`${style.badge} ${STATUS_CLASS[value] || style.statusCompliance}`}>{value}</Badge>
);

export const RiskBadge = ({ value }) => (
  <Badge className={`${style.badge} ${getRiskClass(value)}`}>{value || "N/A"}</Badge>
);

export const RiskEvolution = ({ from, to }) => (
  <span className={style.riskEvolution}>
    <RiskBadge value={from} />
    <span className={style.arrow}>→</span>
    <RiskBadge value={to} />
  </span>
);
